import React, { Component } from "react";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';
import { Link } from 'react-router-dom';

export default class CategoryThumbs extends Component {
	  	
	render () {
		
		let thumbs 		= this.props.thumbs;
		let thumbStyle 	= this.props.thumbStyle;
										
	    return (
	
		    <div className="c-page__block c-page__block--inset-mobile c-page__block--inset c-page__block--load-effect">
				
				<div className="l-grid">
		    
		    		<div className="l-grid__col">
		    		
		    			<div className={'c-projects c-projects--' +  thumbStyle}>
		    				
		    				{thumbs.map((thumb,i) =>
								{
											
									return (
										
										<div className="c-projects__thumb" key={i}>
										
											<Link to={{ pathname: thumb.url }} className="c-projects__thumb__inner">
												
												<div className="c-projects__thumb__media">
													
													{thumb.type == 'image' &&
														<>
															{thumb.lsrc && thumb.psrc &&
																<>
																	<div className="c-projects__thumb__media__portrait">
																		<Image srcset={thumb.psrcset} src={thumb.psrc} />
																	</div>
																	<div className="c-projects__thumb__media__landscape">
																		<Image srcset={thumb.lsrcset} src={thumb.lsrc} />
																	</div>
																</>
															}
															{thumb.src &&
																<Image srcset={thumb.srcset} src={thumb.src} />
															}
														</>
													}
													
													{thumb.type == 'cinemagraph' &&
														<>
															{thumb.psrc && thumb.lsrc &&
																<>
																	<div className="c-projects__thumb__media__portrait">
																		<Cinemagraph src={thumb.psrc} />
																	</div>
																	<div className="c-projects__thumb__media__landscape">
																		<Cinemagraph src={thumb.lsrc} />
																	</div>
																</>
															}
															{thumb.src &&
																<Cinemagraph src={thumb.src} />
															}
														</>
													}
												
												</div>
												
												<h3 className="c-projects__thumb__heading" dangerouslySetInnerHTML={ {__html:thumb.title}}></h3>
																																
											</Link>
											
										</div>
										
									)
									
								}
							)}
							
						</div>
				    
				    </div>
				    
				</div>
		    
		    </div>
		)
	}
}
